import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-77391187"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "policy-document" }
const _hoisted_2 = ["src", "title"]

import PageBack from 'src/components/common/page-back';


export default /*#__PURE__*/_defineComponent({
  props: {
    title: null,
    src: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(PageBack), {
      title: __props.title,
      showHome: false
    }, null, 8, ["title"]),
    _createElementVNode("iframe", {
      class: "policy-document-frame",
      src: __props.src,
      title: __props.title
    }, null, 8, _hoisted_2)
  ]))
}
}

})